import React, { Fragment } from 'react';
import LazyAsset from 'components/LazyAsset';

const AMAZON_AFFILIATE_ID = 'cc3546b2-a8b0-4f6b-8701-d0a00afc6a28';

const ONEJS_URL = `https://z-na.associates-amazon.com/onetag/v2?MarketPlace=US&instanceId=${AMAZON_AFFILIATE_ID}`;

/**
 * This script powers the various tools for Amazon Affiliates:
 * https://affiliate-program.amazon.com/resource-center/all-the-tools-available-to-amazon-associates---a-guide
 *
 * The feature/tool we are using is called "OneLink":
 * https://affiliate-program.amazon.com/resource-center/onelink-launch
 *
 * The script is called "oneTag":
 * https://affiliate-program.amazon.com/help/node/topic/GC4HXR9QP8NHTKZA
 *
 * per amazon oneTag FAQ:
 * https://affiliate-program.amazon.com/help/node/topic/G202164400
 *
 *   "oneTag script analyzes the Amazon links on your site and is responsible
 *   for interacting with our systems to redirect the international visitors to
 *   Amazon.co.uk Amazon.ca, Amazon.it, Amazon.fr, Amazon.es, Amazon.de, and
 *   Amazon.co.jp, when a product match is found. It works for all existing as
 *   well as new links. The oneTag script does not interfere with any other
 *   script on your site."
 *
 * best practices per amazon:
 *
 *  > Integrate oneTag at the footer of the page, so that it gets invoked on
 *    every page.
 *
 * we are only including it on pages that we've tagged as "affiliate" (see
 * PostBundle) because we display an affiliate disclaimer/message only on those
 * pages.
 *
 *  > Use Amazon short links or full links
 *
 * we have a mix of short and full links in our content.
 *
 * NOTES:
 *
 *   - this integration works in certain client-side routing cases
 *     (non-affiliate page --> affiliate page), and fails in others (affiliate
 *     page --> affiliate page). this is because the script executes once on
 *     initial page load.
 *
 *   - this integration does not (yet) handle tagging lazy-loaded linked images.
 *     for this to work, we'd need to make an API call to amazon's JS to have it
 *     re-scan the page for eligible links as each image w/link is rendered.
 *
 *   - this integration has not yet been validated on sponsored posts or other
 *     infinite scroll-style post pages.
 *
 *   - to properly handle infinite scrolling on post pages, we need to scope the
 *     link tagging to the current PostBundle element to ensure that we only tag
 *     links that are in affiliate-tagged content.
 *
 * we'll hopefully have more progress on the above soon.
 *
 */
function AmazonOneTag() {
  return (
    <Fragment>
      <LazyAsset type="js" uri={ONEJS_URL} />
      {/* this div exists to support the async loading functionality. */}
      <div id={`amzn-assoc-ad-${AMAZON_AFFILIATE_ID}`} />
    </Fragment>
  );
}

export default AmazonOneTag;
